import { format } from 'date-fns';
import axios from 'axios';
import qs from 'qs';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyB7VWKjo2RLW3qwZw9EtOxo8MOWVP9jAFk',
  apiKey2: 'AIzaSyBjazldtfc0p1zmYKiVA7tmiNf80Mf6ZMA',
  authDomain: 'vexere-993.firebaseapp.com',
  databaseURL: 'https://vexere-993.firebaseio.com',
  projectId: 'vexere-993',
  storageBucket: 'vexere-993.appspot.com',
  messagingSenderId: '764101058940',
  appId: '1:764101058940:web:885296c52a6bb0b40b04f9',
  measurementId: 'G-Y217JRTVJ7',
};

const FIREBASE_CONFIG_DYNAMIC_LINK = {
  domainUriPrefix: 'https://vexere.page.link',
  androidInfo: {
    androidPackageName: 'com.vexere.vexere',
  },
  iosInfo: {
    iosBundleId: 'com.vexere',
  },
};

const FIREBASE_CONFIG_DYNAMIC_LINK2 = {
  domainUriPrefix: 'https://vexere.page.link',
  androidInfo: {
    androidPackageName: 'com.vexere.vexere',
  },
  iosInfo: {
    iosBundleId: 'com.vexere',
    iosAppStoreId: '1183279479',
  },
  navigationInfo: {
    enableForcedRedirect: 1,
  },
  analyticsInfo: {
    googlePlayAnalytics: {
      utmSource: 'vex_seoflight',
      utmMedium: 'referral',
      utmCampaign: 'seo_flight_route',
    },
  },
};

const FIREBASE_LINK = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${FIREBASE_CONFIG.apiKey}`;
const FIREBASE_LINK2 = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${FIREBASE_CONFIG.apiKey2}`;

export const genDeepLinkQueryObject = (props: any) => {
  const {
    passenger,
    seatClass,
    date,
    returnDate,
    fromId,
    toId,
    airline,
    lang,
  } = props;

  const departD = format(date, 'yyyy-MM-dd');
  const returnD = returnDate
    ? format(new Date(returnDate), 'yyyy-MM-dd')
    : undefined;

  return {
    from: fromId,
    to: toId,
    'date[depart]': departD,
    'date[return]': returnD,
    'passenger[adt]': passenger.adt || 1,
    'passenger[chd]': passenger.chd || 0,
    'passenger[inf]': passenger.inf || 0,
    fare_class: seatClass || 'PT',
    airline,
    type: returnD ? 'return' : undefined,
    lang,
  };
};

export const fetchDynamicLinkForFlight = ({ query, utm_campaign }: { query: any, utm_campaign: string }) => {
  const link = `${
    process.env.NEXT_PUBLIC_GOYOLO || 'https://goyolo.com'
  }/trip-detail?${qs.stringify(query)}`;
  const dynamicLinkConfig = {
    domainUriPrefix: 'https://vexere.page.link',
    androidInfo: {
      androidPackageName: 'com.vexere.vexere',
    },
    iosInfo: {
      iosBundleId: 'com.vexere',
      iosAppStoreId: '1183279479',
    },
    navigationInfo: {
      enableForcedRedirect: 1,
    },
    analyticsInfo: {
      googlePlayAnalytics: {
        utmSource: 'vex_seoflight',
        utmMedium: 'referral',
        utmCampaign: utm_campaign || 'seo_flight_citytocity',
      },
    },
  };
  const data = JSON.stringify({
    dynamicLinkInfo: {
      ...dynamicLinkConfig,
      link,
    },
  });
  return axios({
    url: FIREBASE_LINK2,
    method: 'post',
    headers: {
      'content-type': 'application/json',
    },
    data,
  });
};
